// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2OwnL","largestCol":"styles_largestCol__2qY2P","smallestCol":"styles_smallestCol__2c7EP"};